import { popupSelector } from '../selectors'
import { useStateValue } from '../state_provider'
import { AskInviteePopup } from './ask_invitee_popup'
import { ConferencePopup } from './conference_popup'
import { CustomPopup } from './custom_popup'
import { PhoneCallPopup } from './phone_call_popup'
import { PhysicalPopup } from './physical_popup'

const POPUP_FOR_KIND = {
  custom: CustomPopup,
  physical: PhysicalPopup,
  zoom_conference: ConferencePopup,
  gotomeeting_conference: ConferencePopup,
  google_conference: ConferencePopup,
  microsoft_teams_conference: ConferencePopup,
  webex_conference: ConferencePopup,
  outbound_call: PhoneCallPopup,
  inbound_call: PhoneCallPopup,
  ask_invitee: AskInviteePopup
}

export const LocationPopup = () => {
  const { isOpen, data: { kind } } = popupSelector(useStateValue())

  if (!isOpen) {
    return null
  }

  const Popup = POPUP_FOR_KIND[kind]
  return <Popup />
}
